<template>
  <div class="flex flex-col items-center pb-10">
    <p class="text-blue-500 text-bold text-3xl uppercase">{{ title }}</p>
    <hr class="self-stretch m-auto w-3/5" style="border-bottom: 1px solid rgba(77, 169, 255, 1)"/>
  </div>
</template>

<script>
export default {
  name: "Title",
  props: {
    title: String
  }
}
</script>

<style>

</style>